export default {
  most_popular: '#{{rank}} Più apprezzato',
};
